import { vuexPushArrayToStore } from '../utils/helpers/vuex-push-array-to-store';
import Vue from "vue";
import { EventBus } from '../plugins/eventbus';

export default {

    setIsEmbedForbidden(state, isEmbedForbidden) {
        state.isEmbedForbidden = isEmbedForbidden;

    },
    setActiveLocale(state, locale) {
        state.activeLocale = locale;
    },
    setDefaultLocale(state, locale) {
        state.defaultLocale = locale;
    },
    pushMapObjects(state, {objects, appThemes}) {
        // state.objects = objects;
        /**
         * We check expire object date
         * and check visible_in_app
         * if expireDate > now && publishDate < now - we hide object
         */
        const now = Date.now();
        state.objects = objects.filter(object => {

            if(!shouldShowInCurrentApp(appThemes, object)) {
                return false
            }

            // fallback to support old version - publishDate, expireDate
            if (object.meta.publish && object.meta.publishDate > now) {
                delayObjectPublication(state, object, object.meta.publishDate)
            }

            if (object.meta.expire && object.meta.expireDate > now) {
                delayObjectRemove(state, object, object.meta.expireDate)
            }

            if (object.meta.expire && object.meta.expireDate < now) {
                removeFromBrands(state, object)
            }
            // end fallback
            const startDisplayAt = object.meta.start_display_at ? new Date(object.meta.start_display_at).getTime() : null
            const stopDisplayAt = object.meta.stop_display_at ? new Date(object.meta.stop_display_at).getTime() : null
            
            if (startDisplayAt && startDisplayAt > now) {
                delayObjectPublication(state, object, startDisplayAt)
            }

            if (stopDisplayAt && stopDisplayAt > now) {
                delayObjectRemove(state, object, stopDisplayAt)
            }

            if (stopDisplayAt && stopDisplayAt < now) {
                removeFromBrands(state, object)
            }

            return ( !object.meta.publish || !object.meta.publishDate || object.meta.publishDate < now)
            && ( !object.meta.expire || !object.meta.expireDate || object.meta.expireDate > now )
            && ( !startDisplayAt || startDisplayAt < now)
            && ( !stopDisplayAt || stopDisplayAt > now)
        });
    },
    pushUnfilteredMapObjects(state, objects) {
        /**
         * unfilteredMapObjects is all map object,
         * after we filter objects item by publishDate and expireDate
         * it needs for terminal
         */
        state.unfilteredMapObjects = objects;
    },
    pushCategories(state, listsAndItems) {
        vuexPushArrayToStore(state, 'listsAndItems', listsAndItems)
    },
    setMap(state, map) {
        state.map = map;
    },
    setCustomer(state, customer) {
        state.customer = customer;
    },
    pushMapModels(state, models) {
        vuexPushArrayToStore(state, 'models', models);
    },
    pushMapUnits(state, units) {
        vuexPushArrayToStore(state, 'units', units);
    },
    setAppLoaded(state, value) {
        state.appLoaded = value;
    },
    setTerminalId(state, terminalId) {
        state.terminalId = terminalId;
    },
    setTerminalCode(state, terminalCode) {
        state.terminalCode = terminalCode;
    },
    setMapLoading(state, value) {
        state.mapLoading = value;
    },
    setObjectDistances(state, distances) {
        distances.forEach( d => {
            state.objects.forEach( (o, i, a) => o.unitNames.includes(d.unit) && Vue.set(a[i], 'distance', d.distance) )
        })
    },
    setObjectIndexes(state, numbers) {
        numbers.forEach( n => {
            state.objects.forEach( (o, i, a) => o.id == n.id && Vue.set(a[i], 'index', n.index) )
        })
    },
    setActivePathToState(state, path) {
        state.activePath = path;
    },
    setActiveStep(state, step, index = null) {
        state.activeStep = step;
    },
    setActiveStepIndex(state, index) {
        state.activeStepIndex = index;
    },
    setActiveMapTheme(state, themeName) {
        state.activeMapTheme = themeName;
    },
    setSessionId (state, sessionId) {
        state.sessionId = sessionId
    },
    setLastModified (state, lastModified) {
        state.lastModified = lastModified
    },
    setCanUpdateMapData (state, canUpdateMapData) {
        state.canUpdateMapData = canUpdateMapData
    },
    setIsMapDataUpdateNeeded (state, isMapDataUpdateNeeded) {
        state.isMapDataUpdateNeeded = isMapDataUpdateNeeded
    },
    setLandscapeMode(state, mode) {
        state.landscape = mode;
    },
    setLastModifiedCheckedAt(state, lastModifiedCheckedAt) {
        state.lastModifiedCheckedAt = lastModifiedCheckedAt
    },
    setMobileGuideStartActivate(state, data) {
        state.isMobileGuideStartActivate = data
    },
    setDataSource(state, dataSourceType){
        state.dataSourceType = dataSourceType
    },
    setCompassState(state, isCompassEnabled){
        state.isCompassEnabled = isCompassEnabled
    },
    setCompassOrientationMode(state, value){
        state.isCompassOrientationMode = value;
    },
    setArOrientationMode(state, value){
        state.isArOrientationMode = value;
    },
    setTerminalsList(state, terminalsList) {
        state.terminalsList = terminalsList;
    },
    setMoviesList(state, data) {
        state.moviesList = data;
    },
    setLastMoviesUpdate(state) {
        state.lastMoviesUpdate = +new Date;
    },
    setShowsData(state, data) {
        state.showsData = data;
    },
    setPlayerUrl(state, playerUrl) {
        state.playerUrl = _.get(playerUrl,'[0]') === '/' ? location.origin + playerUrl : playerUrl;
    },
    setMyPosition(state, data) {
        state.myPosition = data;
    },
    setMoviesListTimeout(state, data) {
        state.moviesListTimeout = data;
    },
    setloading(state, data) {
        state.isLoading = data;
    },
};

const delayObjectPublication = (state, object, publishDate) => {
    const now = Date.now(),
        timeToPublish = publishDate - now;
    removeFromBrands(state, object)
    if(timeToPublish < 86400000) { //86400000 is 24h*60m*60s*1000ms, we want check publish only once in a day!
        setTimeout(() => {
            state.objects = [...state.objects, object];
            addToBrands(state, object);
            EventBus.$bus.$emit('map:getUnitDistances');
        }, timeToPublish);
    }
}

const delayObjectRemove = (state, object, expireDate) => {
    const now = Date.now(),
        timeToExpire = expireDate - now;
    if(timeToExpire < 86400000) { //86400000 is 24h*60m*60s*1000ms, we want check publish only once in a day!
        setTimeout(() => {
            state.objects = state.objects.filter(({id}) => id !== object.id)
            removeFromBrands(state, object)
        }, timeToExpire)
    }
}

const removeFromBrands = (state, object) => {
    changeBrands(state, object, -1)
}

const addToBrands = (state, object) => {
    changeBrands(state, object, 1)
}

const changeBrands = (state, object, increment) => {
    object?.lists?.brands?.forEach(brandId => {
        const brand = state.listsAndItems.find(({id}) => id == brandId)
        brand.objectsCount += increment;
    })
}

const shouldShowInCurrentApp = (appThemes, object) => {
    return !object.meta.visible_in_apps ||
    object.meta.visible_in_apps.length === 0 ||
    object.meta.visible_in_apps.includes('all') ||
    appThemes.some(theme => object.meta.visible_in_apps.includes(theme))
}
